import Divider from './Divider';
import DividerVertical from './DividerVertical';

Divider.Vertical = DividerVertical;

export default Divider;
